export default __webpack_public_path__ + "static/media/q22.0c390fa3.png";